import { useEffect } from "react";

const GlobalWatermark = ({
  text = "CONFIDENTIAL",
  fontSize = 20,
  color = "rgba(0,0,0,0.1)",
  rotate = -30,
  gap = 200,
}) => {
    const createWatermark = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        canvas.width = gap;
        canvas.height = gap;
  
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotate * Math.PI) / 180);
        ctx.font = `${fontSize}px Arial`;
        ctx.fillStyle = color;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(text, 0, 0);
  
        const dataUrl = canvas.toDataURL();
  
        document.body.style.backgroundImage = `url(${dataUrl})`;
        document.body.style.backgroundRepeat = "repeat";
      };

  useEffect(() => {

    createWatermark();
    window.addEventListener("resize", createWatermark);

    return () => {
      window.removeEventListener("resize", createWatermark);
      document.body.style.backgroundImage = "";
    };
  });

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (!document.body.style.backgroundImage) {
        createWatermark();
      }
    });
  
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });
  
    return () => observer.disconnect();
  });
  
  return null;
}

export default GlobalWatermark;